import React from 'react';
import { Activity } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-[#1B5E5E] text-white relative overflow-hidden" data-id="element-108">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#C9A84C 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-109"></div>

      <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-110">
        <div className="grid md:grid-cols-12 gap-12 items-center" data-id="element-111">
          <div className="md:col-span-5 flex justify-center" data-id="element-112">
            <div className="w-48 h-48 md:w-64 md:h-64 bg-[#C9A84C] rounded-full flex items-center justify-center shadow-[0_0_60px_rgba(201,168,76,0.4)] relative" data-id="element-113">
              <div className="absolute inset-2 border-2 border-white/30 rounded-full border-dashed animate-[spin_20s_linear_infinite]" data-id="element-114"></div>
              <Activity className="w-24 h-24 text-[#1B5E5E]" data-id="element-115" />
            </div>
          </div>

          <div className="md:col-span-7" data-id="element-116">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-117">
              El Secreto:{' '}
              <span className="text-[#C9A84C]" data-id="element-118">El Método O.S.A.</span>
            </h2>

            <div className="space-y-6 text-lg md:text-xl leading-relaxed text-white/90 font-sans" data-id="element-119">
              <p data-id="element-120">
                El Método O.S.A.{' '}
                <strong className="text-white" data-id="element-121">
                  (Oscilación Sentada Activa)
                </strong>{' '}
                es una técnica de micro-movimientos de bajo impacto que puedes
                hacer{' '}
                <span className="underline decoration-[#C9A84C] decoration-2" data-id="element-122">
                  desde la comodidad de tu silla favorita
                </span>
                .
              </p>

              <p data-id="element-123">
                A diferencia del ejercicio tradicional que causa dolor, este
                método actúa como una <strong data-id="element-124">"bomba hidráulica"</strong>.
                Obliga a los nutrientes y al líquido sinovial a entrar en el
                cartílago sin desgastarlo.
              </p>

              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20 mt-8" data-id="element-125">
                <p className="text-2xl font-bold text-[#C9A84C] text-center m-0" data-id="element-126">
                  Lubrica tu articulación en solo 5 minutos al día.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}